import { z } from "zod";

export const questionSchema = z.object({
  id: z.number(),
  content: z.string(),
  points: z.number(),
});

export const questionCreateSchema = questionSchema.omit({ id: true });
